import { useState, useEffect } from "react";
import axios from "axios";
import { useParams, Link } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import { ArrowLeft, Calendar, MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import { API, waLink } from "@/lib/site";

export default function BlogPostPage() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    axios
      .get(`${API}/posts/${slug}`)
      .then((r) => {
        setPost(r.data);
        setStatus("ok");
        document.title = `${r.data.title} | dausREALTY`;
      })
      .catch(() => setStatus("notfound"));
  }, [slug]);

  return (
    <div className="min-h-screen bg-white" data-testid="blog-post-page">
      <Navbar solid />
      <main className="pt-28 md:pt-36 pb-24">
        <div className="mx-auto max-w-3xl px-6">
          <Link to="/blog" className="inline-flex items-center gap-2 text-sm text-slate-500 hover:text-[#0A2540] transition-colors" data-testid="blog-back-btn">
            <ArrowLeft className="h-4 w-4" /> Kembali ke Blog
          </Link>

          {status === "loading" && <p className="mt-10 text-slate-500">Memuatkan...</p>}
          {status === "notfound" && (
            <div className="mt-10" data-testid="blog-notfound">
              <h1 className="font-heading text-2xl font-bold text-[#0A2540]">Artikel tidak dijumpai</h1>
              <p className="mt-2 text-slate-600">Artikel yang anda cari mungkin telah dialih atau dipadam.</p>
            </div>
          )}

          {status === "ok" && post && (
            <article className="mt-8">
              <span className="flex items-center gap-1.5 text-sm text-slate-400">
                <Calendar className="h-4 w-4" />
                {new Date(post.created_at).toLocaleDateString("ms-MY", { year: "numeric", month: "long", day: "numeric" })}
              </span>
              <h1 className="mt-3 text-3xl sm:text-4xl font-extrabold tracking-tight text-[#0A2540] leading-tight">{post.title}</h1>
              {post.excerpt && <p className="mt-4 text-lg text-slate-600 leading-relaxed">{post.excerpt}</p>}
              {post.cover_image && (
                <img src={post.cover_image} alt={post.title} className="mt-8 w-full rounded-2xl border border-slate-200 object-cover" loading="lazy" />
              )}
              <div className="prose prose-slate mt-8 max-w-none prose-headings:font-heading prose-headings:text-[#0A2540] prose-a:text-[#1D4ED8] prose-strong:text-[#0A2540]" data-testid="blog-content">
                <ReactMarkdown>{post.content}</ReactMarkdown>
              </div>

              <div className="mt-12 rounded-2xl bg-[#0A2540] p-8 text-center">
                <h3 className="font-heading text-xl font-bold text-white">Sedia untuk mohon pinjaman anda?</h3>
                <p className="mt-2 text-slate-300 text-sm">Hubungi saya untuk semakan kelayakan percuma.</p>
                <div className="mt-5 flex flex-col sm:flex-row gap-3 justify-center">
                  <a href={waLink()} target="_blank" rel="noopener noreferrer">
                    <Button className="bg-[#10B981] hover:bg-[#0e9e6e] text-white rounded-full"><MessageCircle className="mr-2 h-4 w-4" /> WhatsApp Saya</Button>
                  </a>
                  <Link to="/#mohon">
                    <Button variant="outline" className="border-white/30 bg-transparent text-white hover:bg-white/10 rounded-full">Semak Kelayakan</Button>
                  </Link>
                </div>
              </div>
            </article>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}
